import { Classes, Icon, Position, Tooltip } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import classNames from 'classnames'
import { Entity } from 'shared-libs/models/entity'
import {
  getSematextLinkForUserId,
  getKibanaUrlForEntity,
  getAmplitudeLinkForUserId,
  getLogRocketSessionForEntity,
  getLogRocketLinkForUserId,
} from './utils'
import './_insights-link.scss'
import _ from 'lodash'
import { Formatter } from 'shared-libs/helpers/formatter'
import { SchemaIds } from 'shared-libs/models/schema'

interface IInsightsLinkProps {
  href: string
  children: React.ReactNode
}

export const AmplitudeLink = ({ userId }: { userId: string }) => (
  <InsightsLink href={getAmplitudeLinkForUserId(userId)}>
    Amplitude data
    <Tooltip
      content="For data before Q3 2022, you may need to switch Amplitude projects. For data after Q2 2023 use the Sematext link."
      position={Position.BOTTOM}
    >
      <Icon className="insights-panel__icon" icon={IconNames.INFO_SIGN} />
    </Tooltip>
  </InsightsLink>
)

export const SematextLink = ({ user, entity }: { user: Entity; entity?: Entity }) => (
  <InsightsLink href={getSematextLinkForUserId(user, entity)}>Sematext client data</InsightsLink>
)

export const KibanaLink = ({ entity }: { entity: Entity }) => (
  <InsightsLink href={getKibanaUrlForEntity(entity)}>Kibana logs</InsightsLink>
)

export const LogRocketLinks = ({ entity }: { entity: Entity }) => {
  if (entity.isStoryboardExecution) {
    const sessions = getLogRocketSessionForEntity(entity)
    return (
      <div>
        {_.map(sessions, (session) => {
          const linkLabel =
            'LogRocket-' + session.userName + '-' + Formatter.formatDateTime(session.creationDate)
          return <InsightsLink href={session.sessionURL}>{linkLabel}</InsightsLink>
        })}
      </div>
    )
  } else if (entity.hasMixin(SchemaIds.USER)) {
    return <InsightsLink href={getLogRocketLinkForUserId(entity.uniqueId)}>LogRocket Sessions</InsightsLink>
  } else {
    return null
  }
}

export const InsightsLink = (props: IInsightsLinkProps) => {
  const { children, href } = props
  return (
    <a
      className={classNames('insights-link', Classes.BUTTON)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}
